import { __awaiter, __generator } from "tslib";
import { fetchSiteFeatures } from '../../api/site-settings';
/**
 * Checks whether provided site feature is enabled
 * @param siteFeature One of `SiteFeature` enumeration values
 * @returns Promise with boolean value indicating whether provided site feature is enabled
 * @async
 */
export var isSiteFeatureEnabled = function (siteFeature) { return __awaiter(void 0, void 0, void 0, function () {
    var siteFeatures;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchSiteFeatures([siteFeature])];
            case 1:
                siteFeatures = _a.sent();
                return [2 /*return*/, Array.isArray(siteFeatures) && siteFeatures.length > 0 && !!siteFeatures[0].value];
        }
    });
}); };
